import { io } from "socket.io-client";
import BASE_URL from "./config/api";

const socket = io(BASE_URL || undefined, {
  transports: ["websocket"],
  upgrade: false, // prevents fallback to polling
  autoConnect: false,
});

export const setSocketAuthToken = (token) => {
  const normalizedToken = String(token || '').trim();
  socket.auth = normalizedToken ? { token: normalizedToken } : {};
};

export const clearSocketAuthToken = () => {
  socket.auth = {};
};

export const disconnectAuthenticatedSocket = () => {
  if (socket.connected || socket.active) {
    socket.disconnect();
  }
  clearSocketAuthToken();
};

export default socket;
